// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31Uug","colBig":"styles_colBig__1N6cH","colSmall":"styles_colSmall__1RKf1"};